import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class PrestigeDamageView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     */
    constructor(parentId, damage) {
        super(parentId, parentId + '_prestige');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedPrestigeDamageMultiplier = new BigNum(0);
        /**
         * @type {string}
         */
        this.prestigeBonusString = null;

        /**
         * @type {HTMLElement}
         */
        this.body = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // prestige
        ////////////////////////////////////

        const container = Page.createElement('div', parentElement, this.getElementId(), 'mine-damage-panel-main-section');

        const headerElement = Page.createElement('div', container, null, 'mine-damage-panel-section-header');
        headerElement.innerHTML = 'Prestige';

        this.body = Page.createElement('div', container, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const damageMultiplier = this.damage.prestigeDamageMultiplier;

        /////////////////////////////////////
        // Prestige Bonus
        /////////////////////////////////////

        if (!this.prestigeBonusString || !damageMultiplier.equals(this.displayedPrestigeDamageMultiplier)) {
            this.displayedPrestigeDamageMultiplier.copy(damageMultiplier);
            this.prestigeBonusString = NumberFormatter.formatBigNum(damageMultiplier);
            this.body.innerHTML = this.prestigeBonusString;
        }

        super.updateViewContents();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}